import { Component } from "@angular/core";
import { TCITenantSelectorType } from "@tci/common";
import {
    ITCIUploadComponentDroppedFilesOutput,
    ITCIUploadSupportedFile,
    ITCIUploadComponentInput
} from "../../../ng-tenant/tci-tenant-components";
import { BaseCreateAppImportV2Component } from "./base-create-app-import.component";
/**
 * Wrapper component for base-create-app-import component.
 * Uses existing Class and HTML template of BaseCreateAppImportV2Component but different selector.
 */
@Component({
    selector: TCITenantSelectorType.TCI_APP_CREATE_GRAPHQL_SCHEMA.toString(),
    templateUrl: "./base-create-app-import.component.html"
})
export abstract class BaseCreateAppImportGraphQLComponent<E, I extends ITCIUploadComponentInput,
    O extends ITCIUploadComponentDroppedFilesOutput | boolean> extends BaseCreateAppImportV2Component<E, I, O> {

    constructor() {
        super();
    }

    public abstract getFileSpecs(): ITCIUploadSupportedFile[];
}
